module.exports = __webpack_public_path__ + "img/去城市周边探索自然及野生动物.85f0bc90.png";